import { useEffect, useRef, useState } from "react";
import { FileText, Download, Loader2, X } from "lucide-react";
import { invitoMomento } from "./InstallaHome";
import { AnalisiProButtons } from "./ClienteAnalisiPro";

// Report mensili dell'impianto: elenco dei mesi e download del PDF
export function ClienteReport({ src, onClose: chiudi, pro }) {
  const scaricato = useRef(false);
  // l'invito ad installare l'app arriva quando il cliente chiude l'elenco, dopo aver scaricato un report
  const onClose = () => { chiudi(); if (scaricato.current) setTimeout(() => invitoMomento("Vuoi ritrovare i tuoi report sempre qui? Installa l'app in 2 tocchi"), 800); };
  const [lista, setLista] = useState(null);
  const [periodo, setPeriodo] = useState("mensile");
  const [busy, setBusy] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => { src.reportLista().then((r) => { setLista(r.report || []); setPeriodo(r.periodo || "mensile"); }).catch(() => setLista([])); }, [src]);
  const scarica = async (m) => {
    setBusy(m.mese); setErr("");
    try {
      const blob = await src.reportPdf(m.mese);
      const url = URL.createObjectURL(new Blob([blob], { type: "application/pdf" }));
      const a = document.createElement("a");
      a.href = url; a.download = `Report impianto ${m.titolo}.pdf`;
      document.body.appendChild(a); a.click(); a.remove();
      setTimeout(() => URL.revokeObjectURL(url), 5000);
      scaricato.current = true;
    } catch { setErr("Non è stato possibile preparare il report. Riprova tra poco."); }
    setBusy(null);
  };
  return (
    <div className="fixed inset-0 z-40 flex items-end justify-center bg-slate-900/40 backdrop-blur-sm sm:items-center" onClick={onClose} data-testid="cliente-report-modal">
      <div className="max-h-[90vh] w-full max-w-md overflow-y-auto rounded-t-3xl bg-white p-6 shadow-2xl sm:rounded-3xl" onClick={(e) => e.stopPropagation()}>
        <div className="mb-1 flex items-center justify-between">
          <h3 className="text-lg font-bold text-slate-900">{periodo === "quadrimestrale" ? "Report quadrimestrali" : "Report mensili"}</h3>
          <button type="button" onClick={onClose} className="rounded-full p-2 text-slate-400 hover:bg-slate-100" aria-label="Chiudi" data-testid="cliente-report-close"><X className="h-5 w-5" /></button>
        </div>
        {pro && src.headers && (
          <div className="mb-5" data-testid="cliente-report-analisi">
            <p className="mb-2 text-[11px] font-bold uppercase tracking-widest text-[#C17F59]">Analisi avanzate</p>
            <AnalisiProButtons src={src} />
          </div>
        )}
        <p className="mb-4 text-sm text-slate-500">{periodo === "quadrimestrale" ? "Ogni quattro mesi Vesta prepara un resoconto del tuo impianto, con i consigli per usarlo al meglio." : "Ogni mese Vesta prepara un resoconto del tuo impianto, con i consigli per usarlo al meglio."}</p>
        {lista === null ? <Loader2 className="mx-auto my-6 h-6 w-6 animate-spin text-sky-500" /> : !lista.length ? (
          <p className="py-4 text-sm text-slate-500" data-testid="cliente-report-vuoto">{periodo === "quadrimestrale" ? "Il primo report sarà disponibile alla fine del quadrimestre." : "Il primo report sarà disponibile all'inizio del prossimo mese."}</p>
        ) : (
          <ul className="space-y-2" data-testid="cliente-report-lista">
            {lista.map((m) => (
              <li key={m.mese}>
                <button type="button" disabled={!!busy} onClick={() => scarica(m)} data-testid={`cliente-report-${m.mese}`}
                  className="flex w-full items-center gap-3 rounded-2xl bg-slate-50 px-4 py-3 text-left transition-colors hover:bg-sky-50 disabled:opacity-60">
                  <FileText className="h-5 w-5 text-sky-600" />
                  <span className="flex-1 font-semibold text-slate-800">{m.titolo}</span>
                  {busy === m.mese ? <span className="flex items-center gap-1 text-xs text-slate-500"><Loader2 className="h-4 w-4 animate-spin" />preparo…</span> : <Download className="h-4 w-4 text-slate-400" />}
                </button>
              </li>
            ))}
          </ul>
        )}
        {err && <p className="mt-3 text-sm text-rose-600" data-testid="cliente-report-errore">{err}</p>}
        <p className="mt-4 text-[11px] text-slate-400">Dati indicativi: non vanno considerati ai fini fiscali o legali.</p>
      </div>
    </div>
  );
}
